import { fetchOrganizationSettings } from '../api.js';
import {
    REQUEST_DISCOUNT_ROLLOUT,
    RECEIVE_DISCOUNT_ROLLOUT,
    RESET_DISCOUNT_ROLLOUT,
} from './discountServiceTypes.js';

/**
 * Clear the flag. Dispatched on organization switch so the next read is for the new organization.
 */
export function resetDiscountRollout() {
    return { type: RESET_DISCOUNT_ROLLOUT };
}

/**
 * Thunk: read the organization's `huskyCloudSettings.useNewDiscountApi`, once per organization. No-ops while a read
 * for this organization is in flight or done, so any component can call it from an effect.
 *
 * root API returns the flag already normalised to a boolean for user tokens. Any failure — no permission, network,
 * no huskyCloudSettings at all — resolves to `false`, exactly as the cabinet stays on root API when it cannot read
 * the flag.
 * @returns {function}
 */
export function fetchDiscountRollout() {
    return async (dispatch, getState) => {
        const group = getState().user && getState().user.group;
        const groupId = group && group.Id;
        if (!groupId) {
            return false;
        }
        const { discountRollout } = getState();
        if (discountRollout.groupId === groupId && (discountRollout.fetching || discountRollout.fetched)) {
            return discountRollout.useNewDiscountApi;
        }

        dispatch({ type: REQUEST_DISCOUNT_ROLLOUT, groupId });
        let useNewDiscountApi = false;
        try {
            const settings = await fetchOrganizationSettings(group);
            useNewDiscountApi = Boolean(settings && settings.huskyCloudSettings
                && settings.huskyCloudSettings.useNewDiscountApi === true);
        } catch (error) {
            console.warn('[discounts] could not read the organization rollout flag; using the classic page', error);
        }
        // The organization may have changed while this was in flight; only the current one's answer counts.
        if (getState().user.group && getState().user.group.Id === groupId) {
            dispatch({ type: RECEIVE_DISCOUNT_ROLLOUT, groupId, useNewDiscountApi });
        }
        return useNewDiscountApi;
    };
}
